const endpoints = {
  auth: {
    login: "api/auth/token/",
    logout: "api/auth/logout/",
    registerIntastaller: "api/auth/registration-installer/",
    registerCustomer: "api/auth/registration-customer/",
    resetPassword: "api/auth/reset-password/",
    changePassword: "api/auth/change-password/",
    refresh: "api/auth/token/refresh/",
  },
  users: {
    me: "api/v1/users/me/",
    enableInstaller: "api/v1/users/change-status-installer/",
    enableCustomer: "api/v1/users/change-status-customer/",
    enableSupport: "api/v1/users/change-status-support/",
    customers: "api/v1/users/show-customers/",
    installers: "api/v1/users/show-installers/",
    supports: "api/v1/users/show-supports/",
    updateInstaller: "api/v1/users/update-installer/",
    updateCustomer: "api/v1/users/update-customer/",
    createSupport: "api/v1/users/create-support/",
    updateSupport: "api/v1/users/update-support/",
    deleteInstaller: "api/v1/users/delete-installer/",
    deleteCustomer: "api/v1/users/delete-customer/",
    deleteSupport: "api/v1/users/delete-support/",
  },
  plant: {
    plants: "api/v1/plants/show-plants/",
    create: "api/v1/plants/create-plant/",
    update: "api/v1/plants/update-plant/",
    delete: "api/v1/plants/delete-plant/",
  },
  eklok: {
    ekloks: "api/v1/ekloks/show-ekloks/",
    create: "api/v1/ekloks/create-eklok/",
    update: "api/v1/ekloks/update-eklok/",
    delete: "api/v1/ekloks/delete-eklok/",
    pair: "api/v1/ekloks/customer-eklok-pair/",
    updateStatus: "api/v1/mqtt/eklok-update-status/",
    activation: "api/v1/ekloks/activation-eklok/",
    otpSupport: "api/v1/ekloks/otp-support-eklok/",
    updateReleStatus: "api/v1/mqtt/eklok-rele-status/",
  },
  connection: {
    openConnection: "api/v1/connections/start-connection-eklok/",
    closeConnection: "api/v1/connections/close-connection-eklok/",
  },
  version: {
    version: "api/v1/get-release-version/",
  },
  mobileFrame: {
    stopAllActionEvent: "api/v1/mqtt/eklok-event/",
    setActionEvent: "api/v1/mqtt/eklok-command/",
    commandList: "api/v1/mqtt/eklok-command/?eklok=",
    eventStatusList: "api/v1/mqtt/eklok-event/?eklok=",
    getSoundBlockStatus: "api/v1/mqtt/eklok-sound-block-status/?eklok=",
    setSoundBlockStatus: "api/v1/mqtt/eklok-sound-block-status/",
    assistanceData: "api/v1/mqtt/eklok-support-info/?eklok=",
    calendarEventData: "api/v1/mqtt/eklok-calendar-event/?action=list",
    deleteCalendarEventData: "api/v1/mqtt/eklok-calendar-event/?action=remove",
    addCalendarEventData: "api/v1/mqtt/eklok-calendar-event/?action=add",
    setEklokLineStatus: "api/v1/mqtt/eklok-line-status/",
  },
};

export default endpoints;
